export const PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  RENT: 'rent',
  PURCHASE: 'sale',
  MEMBER_ONLY: 'memberOnly',
};

export const PAYMENT_PERMISSIONS = {
  UNLIMITED_STREAMING: 'unlimitedStreaming',
  INSTANT_ACCESS: 'instantAccess',
  MONTHLY_PAYMENT: 'monthlyPayment',
  SINGLE_VIDEO: 'singleVideo',
  ONE_PAYMENT: 'onePayment',
  SINGLE_VIDEO_STREAMING: 'singleVideoStreaming',
  STREAMING_PERIOD: 'streamingPeriod',
  UNLIMITED_DOWNLOADS: 'unlimitedDownloads',
  DOWNLOAD_ANY_TIME: 'downloadAnytime',
};

const {
  UNLIMITED_STREAMING,
  INSTANT_ACCESS,
  MONTHLY_PAYMENT,
  SINGLE_VIDEO,
  ONE_PAYMENT,
  SINGLE_VIDEO_STREAMING,
  STREAMING_PERIOD,
  UNLIMITED_DOWNLOADS,
  DOWNLOAD_ANY_TIME,
} = PAYMENT_PERMISSIONS;

const PAYMENT_PERMS = {
  [PAYMENT_TYPE.SUBSCRIPTION]: [
    UNLIMITED_STREAMING,
    INSTANT_ACCESS,
    MONTHLY_PAYMENT,
  ],
  [PAYMENT_TYPE.PURCHASE]: [SINGLE_VIDEO, ONE_PAYMENT, UNLIMITED_STREAMING],
  [PAYMENT_TYPE.RENT]: [SINGLE_VIDEO_STREAMING, STREAMING_PERIOD],
  [PAYMENT_TYPE.MEMBER_ONLY]: [SINGLE_VIDEO, UNLIMITED_STREAMING],
};

const DOWNLOAD_PERMS = {
  [PAYMENT_TYPE.SUBSCRIPTION]: [UNLIMITED_DOWNLOADS],
  [PAYMENT_TYPE.PURCHASE]: [DOWNLOAD_ANY_TIME],
  [PAYMENT_TYPE.RENT]: [],
  [PAYMENT_TYPE.MEMBER_ONLY]: [DOWNLOAD_ANY_TIME],
};

export function getPaymentPermissions({ paymentType, downloadEnabled }) {
  const permissions = PAYMENT_PERMS[paymentType];
  return downloadEnabled
    ? permissions.concat(DOWNLOAD_PERMS[paymentType])
    : permissions;
}

export const CHARGE_INTENT = {
  SALE: 'SALE',
  RECURRING: 'RECURRING',
};

export const CHARGE_INTENT_BY_TYPE = {
  [PAYMENT_TYPE.SUBSCRIPTION]: CHARGE_INTENT.RECURRING,
  [PAYMENT_TYPE.PURCHASE]: CHARGE_INTENT.SALE,
  [PAYMENT_TYPE.RENT]: CHARGE_INTENT.SALE,
  [PAYMENT_TYPE.MEMBER_ONLY]: null,
};
